<template>
  <div id="Tasks">
		<div id="tabs">
			<div 
				:class="{'tab':true,'selected':selectedTab==='adminTask'}"
				@click="selectedTab='adminTask'">İdari Görevler</div>
			<div 
				:class="{'tab':true,'selected':selectedTab==='nonUniExp'}"
				@click="selectedTab='nonUniExp'">Üniversite Dışı Deneyim</div>
		</div>

		<div id="wrapper">
			<div
				class="item"
				v-for="(task, index) in selectedTab==='adminTask'?tasks.adminTasks:tasks.nonUniExp"
				:key="index">
					<h2 class="title">{{task.taskTitle}}</h2>
					<div id="tag-wrapper">
						<span class="tag">{{task.place}}</span>
						<span class="tag">{{task.year}}</span>
					</div>
			</div>
		</div>
		
	</div>
</template>

<script>
	const firebase = require('firebase/app');

  export default {
    name: 'Tasks',
    data() {
      return {
        selectedTab: 'adminTask',
        tasks: [],
      }
    },
    created(){
			firebase.database().ref('/TasksItem').once('value').then((snapshot) => {
				this.tasks = snapshot.val(); 
			});
		},
  }
</script>

<style lang="scss" scoped>
	#tabs{
		display: flex;
		height: auto;
		width: fit-content;
		flex-direction: row;
		margin-top: 1em;
		margin-left: auto;
		margin-right: auto;

		.tab{
			padding: 20px;
			margin: 0 1em;
			width: 20vw;
			z-index: 3;
			position: relative;
			
			display: flex;
			align-self: center;
			justify-content: center;
			
			font-size: .6em;
			border-radius: 30px;
			transition: font-size .5s;

			@media screen and (max-width: 1440px){
				font-size: .55em;
				transition: font-size .5s;
			}

			@media screen and (max-width: 1280px){
				font-size: .50em;
				transition: font-size .5s;
			}

			@media screen and (max-width: 1024px){
				font-size: .45em;
				transition: font-size .5s;
			}

			@media screen and (max-width: 768px){
				width: 30vw;
				font-size: .5em;
				transition: font-size .5s;
			}

			@media screen and (max-width: 600px){
				width: 25vw;
				font-size: .4em;
				transition: font-size .5s;
			}

			@media screen and (max-width: 425px){
				width: 20vw;
				font-size: .5em;
				transition: font-size .5s;
			}

			@media screen and (max-width: 375px){
				width: 25vw;
				font-size: .4em;
				transition: font-size .5s;
			}

			background-color: white;
			color: #333;
			filter: drop-shadow(0 3px 6px #333);
			transform: scale3d(1, 1, 1);
			transition: filter 1s, transform 1s, background-color .5s, color .5s, font-weight .5s;
		
			&:hover{
				filter: drop-shadow(0 5px 10px #333);
				transform: scale3d(1.1, 1.1, 1.1); 
				transition: filter 1s, transform 1s, background-color .5s, color .5s, font-weight .5s;
				z-index: 4;
				cursor: pointer;
			}

			&.selected{
				font-weight: bold;
				background-color: #333;
				color: white;
			}
		}
	}

	#wrapper{
		display: flex;
		flex-direction: row;

		.item{
			background-color: white;
			border-radius: 2em;
			display: flex;
			flex-direction: column;
			box-shadow: 0 5px 5px #333333b0;
			padding: .5em;
			margin: .5em;
			
			.title{
				text-align: center;
				text-shadow: 0 3px 3px #33333379;
				color: #3b3b3b;
				transform: scale3d(1, 1, 1);
				margin: .2em 0;
				font-size: 1em;
				transition: all .5s;

				@media screen and (max-width: 600px){
					font-size: .9em;
					transition: all .5s;
				}

				@media screen and (max-width: 425px){
					font-size: .6em;
					transition: all .5s;
				}
			}

			#tag-wrapper{
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				justify-content: center;
				
				.tag{
					color: white;
					width: fit-content;
					font-size: .5em;
					border-radius: 100em;
					background-color: #00e070;
					filter: drop-shadow(0 2px 3px #333);
					-webkit-filter: drop-shadow(0 2px 3px #333);
					margin: 10px 15px;
					transition: all .5s;

					@media screen and (max-width: 768px){
						font-size: .5em;
						padding: 20px 30px;
						transform: all .5s;
					}

					@media screen and (max-width: 600px){
						font-size: .4em;
						padding: 15px 30px;
						transition: all .5s;
					}

					@media screen and (max-width: 425px){
						font-size: .3em;
						transition: all .5s;
					}
				}
			}
		}
	}
</style>